module.exports = __webpack_public_path__ + "images/dashboard_image.png";